import React from 'react';

const Navigation = ({ view, isAdmin, onViewChange, country }) => {
  const showRebelnet = country === 'IT';
  const handleViewChange = (newView) => {
    onViewChange(newView);
    localStorage.setItem('currentView', newView);
  };

  const isActive = (views) => views.includes(view);

  return (
    <nav className="bottom-nav">
      <button
        className={`bottom-nav-item ${isActive(['stats', 'contracts']) ? 'active' : ''}`}
        onClick={() => handleViewChange('stats')}
        aria-label="Produzione"
      >
        <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
          <path d="M3 13h2v8H3v-8zm4-6h2v14H7V7zm4-4h2v18h-2V3zm4 9h2v9h-2v-9zm4-3h2v12h-2V9z"/>
        </svg>
        <span className="bottom-nav-label">Produzione</span>
      </button>

      {showRebelnet && (
        <button
          className={`bottom-nav-item ${isActive(['rebelnet-stats', 'rebelnet-contracts', 'rebelnet-config']) ? 'active' : ''}`}
          onClick={() => handleViewChange('rebelnet-stats')}
          aria-label="Rebelnet"
        >
          <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
            <path d="M16 6l2.29 2.29-4.88 4.88-4-4L2 16.59 3.41 18l6-6 4 4 6.3-6.29L22 12V6z"/>
          </svg>
          <span className="bottom-nav-label">Rebelnet</span>
        </button>
      )}

      <button
        className={`bottom-nav-item ${isActive(['tracking']) ? 'active' : ''}`}
        onClick={() => handleViewChange('tracking')}
        aria-label="Altre Notifiche"
      >
        <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
          <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 14H7v-2h5v2zm5-4H7v-2h10v2zm0-4H7V7h10v2z"/>
        </svg>
        <span className="bottom-nav-label">Tracking</span>
      </button>

      <button
        className={`bottom-nav-item ${isActive(['operational']) ? 'active' : ''}`}
        onClick={() => handleViewChange('operational')}
        aria-label="Operativo"
      >
        <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
          <path d="M12 22c1.1 0 2-.9 2-2h-4c0 1.1.89 2 2 2zm6-6v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2z"/>
        </svg>
        <span className="bottom-nav-label">Operativo</span>
      </button>

      <button
        className={`bottom-nav-item ${isActive(['settings', 'admin']) ? 'active' : ''}`}
        onClick={() => handleViewChange('settings')}
        aria-label="Impostazioni"
      >
        <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
          <path d="M19.14 12.94c.04-.3.06-.61.06-.94 0-.32-.02-.64-.07-.94l2.03-1.58c.18-.14.23-.41.12-.61l-1.92-3.32c-.12-.22-.37-.29-.59-.22l-2.39.96c-.5-.38-1.03-.7-1.62-.94l-.36-2.54c-.04-.24-.24-.41-.48-.41h-3.84c-.24 0-.43.17-.47.41l-.36 2.54c-.59.24-1.13.57-1.62.94l-2.39-.96c-.22-.08-.47 0-.59.22L2.74 8.87c-.12.21-.08.47.12.61l2.03 1.58c-.05.3-.09.63-.09.94s.02.64.07.94l-2.03 1.58c-.18.14-.23.41-.12.61l1.92 3.32c.12.22.37.29.59.22l2.39-.96c.5.38 1.03.7 1.62.94l.36 2.54c.05.24.24.41.48.41h3.84c.24 0 .44-.17.47-.41l.36-2.54c.59-.24 1.13-.56 1.62-.94l2.39.96c.22.08.47 0 .59-.22l1.92-3.32c.12-.22.07-.47-.12-.61l-2.01-1.58zM12 15.6c-1.98 0-3.6-1.62-3.6-3.6s1.62-3.6 3.6-3.6 3.6 1.62 3.6 3.6-1.62 3.6-3.6 3.6z"/>
        </svg>
        <span className="bottom-nav-label">Impostazioni</span>
      </button>
    </nav>
  );
};

export default Navigation;
